import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as projectReducer from "containers/Project/reducer";
import * as viewReducer from "containers/View/reducer";
import * as createReducer from "containers/CreateWizard/reducer";
import * as setupReducer from "containers/Setup/reducer";

import OptimizerTile from "components/Tiles/OptimizerTile";

import { isEnabled } from "utils/featureFlags";

class ProjectItemContainer extends React.Component {
  render() {
    const { isTile, isHighlight, fetchNext, isJobsLoading, data } = this.props;

    return <OptimizerTile {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateDatasetId: (datasetId) => dispatch(setupReducer.updateDatasetId("new", datasetId))
});

const mapStateToProps = (state, ownProps) => {
  const data = projectReducer.getProject(state, ownProps.id);
  let optimized;
  if (ownProps.isConsumer) {
    optimized = projectReducer.getOptimized(state, ownProps.id);
  }
  return {
    data: data,
    optimized: optimized,
    overallBusinessConstraints: setupReducer.getOverallBusinessConstraints(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ProjectItemContainer);
